import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Input,
  Tooltip,
  Flex,
} from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  ExportOutlined,
  ReloadOutlined,
  FilterOutlined,
  PlusCircleOutlined,
  FileExcelOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_MAIN_INVESTIGATE_ONLINE,
  PUT_STATUS_INVESTIGATE_ONLINE,
} from "../../API/apiUrls";

import axios from "axios";
import dayjs from "dayjs";
import { ThaiRangePicker } from "../../../hook/ThaiDatePicker";
import ExportListInvestigateRound from "./modal/ExportListInvestigateRound";
import AddInvestigate from "./modal/AddInvestigate";
import { exportExcelReport } from "./report/ExportExcelReport";

const Main = () => {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLength, setTableLength] = useState(0);
  const [
    isModalExportListInvestigateRound,
    setIsModalExportListInvestigateRound,
  ] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dateSearch, setDateSearch] = useState([]);
  const [searchInput, setSearchInput] = useState(null);
  const [isModalAdd, setIsModalAdd] = useState(false);
  const [dataRecord, setDataRecord] = useState();
  const [advanceSearch, setAdvanceSearch] = useState(true);
  const toggle = () => setAdvanceSearch((v) => !v);
  const [arrow, setArrow] = useState("Show");

  const loadData = useCallback(async () => {
    console.log("2.loadData");
    setLoading(true);
    const payload = {
      statusActiveInvestigate: 1,
    };

    try {
      await axios
        .post(BASE_URL_BEN + POST_MAIN_INVESTIGATE_ONLINE, payload, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          console.log("res.data", res?.data);
          let i = 1;
          if (res.status === 200 && res.data.success !== "ไม่พบข้อมูล") {
            const newData = res?.data?.map((item) => ({
              ...item,
              key: i++,
            }));
            setDataRecord(newData);
            filterData(newData);
          } else {
            message.warning("ไม่พบข้อมูลที่รอส่งสืบ");
            setArrayTable([]);
            setDataArr([]);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
          setArrayTable([]);
          setDataArr([]);
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const filterData = (data) => {
    if (data) {
      console.log("5.filterData");

      let filteredData = data.filter((item) => !item.dateOnlineInvestigate);
      filteredData = filteredData.filter(
        (item) => !String(item.CONTNO ?? "").startsWith("1-")
      );

      // if (userCompany === "3") {
      //   filteredData = data.filter((item) => item.company === 2);
      // } else {
      //   filteredData = data.filter((item) => item.company === 1);
      // }
      // console.log("filteredData", filteredData);
      const sortedData = filteredData.sort((a, b) => {
        // ถ้า a ไม่มี investigation_date ให้เอาไว้ล่าง
        if (!a.dateCeoInvestigate && b.dateCeoInvestigate) return 1;
        // ถ้า b ไม่มี investigation_date ให้เอาไว้ล่าง
        if (a.dateCeoInvestigate && b.dateCeoInvestigate) return -1;
        // ถ้าทั้งคู่มี investigation_date ให้เปรียบเทียบปกติ (ล่าสุดก่อน)
        if (a.dateCeoInvestigate && b.dateCeoInvestigate) {
          return (
            new Date(b.dateCeoInvestigate) - new Date(a.dateCeoInvestigate)
          );
        }
        return 0; // ถ้าทั้งคู่เป็น null
      });

      setArrayTable(sortedData);
      setDataArr(sortedData);
      setTableLength(sortedData?.length);
    } else {
      console.error("data is not an array or is undefined");
      setTableLength(0);
    }
  };

  const handlefilterData = () => {
    console.log("handlefilterData");

    setLoading(true);
    setSelectedRowKeys([]);
    setSelectedRows([]);

    // 1) ตั้งต้นจาก data เดิม
    let result = Array.isArray(dataArr) ? [...dataArr] : [];

    // 2) ค้นหาด้วยข้อความ (เลขสัญญา)
    const q = (searchInput ?? "").trim().toLowerCase();
    if (q) {
      result = result.filter((item) =>
        String(item.CONTNO ?? "")
          .toLowerCase()
          .includes(q),
      );
    }

    // 4) กรองช่วงวันที่ (ต้องมี 2 ค่า)
    if (Array.isArray(dateSearch) && dateSearch[0] && dateSearch[1]) {
      const startTs = dayjs(dateSearch[0]).startOf("day").valueOf();
      const endTs = dayjs(dateSearch[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        if (!item.dateCeoInvestigate) return false; // ถ้าไม่มีวันที่ ตัดออก (ปรับตามต้องการ)
        const t = dayjs(item.dateCeoInvestigate).valueOf(); // เวลาเป็นมิลลิวินาที
        return t >= startTs && t <= endTs; // อยู่ในช่วง (รวมปลายทั้งสองข้าง)
      });

      console.log("result", result);
    }

    // 5) ใส่ผลลัพธ์กลับลงตาราง
    setArrayTable(result);
    setTableLength?.(result.length);

    if (result.length === 0) message.info("ไม่พบข้อมูลที่ตรงเงื่อนไข");

    setLoading(false);
  };

  const putDataSend = async () => {
    setLoading(true);
    try {
      const res = await axios.put(
        BASE_URL_BEN + PUT_STATUS_INVESTIGATE_ONLINE,
        selectedRows,
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );

      const { status, data } = res;
      console.log(data);

      if (status === 200) {
        message.success("อัพเดทข้อมูลสำเร็จ");
        loadData();
      } else if (status === 201) {
        message.warning(String(data?.OK));
        loadData();
      } else {
        message.success(`สำเร็จ (รหัส ${status})`);
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }
      console.error("insertData error:", error);
    } finally {
      setLoading(false);
      setSelectedRowKeys([]);
      setSelectedRows([]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
    console.log(selectedRows);
  };

  const renderStatus = (record) => {
    let color = record.statusActiveInvestigate === 1 ? "blue" : "green";
    return (
      <Tag color={color} key={record.id} style={{ textAlign: "center" }}>
        {record.statusActiveInvestigate ? "รอดำเนินการ" : "ส่งสืบแล้ว"}
      </Tag>
    );
  };

  const reloadData = (value) => {
    console.log(value);
    if (value) {
      loadData();
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
    },

    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",
      render: (text, record) => <>{record.CONTNO}</>,
    },
    {
      title: "ชื่อ-กสุล",
      dataIndex: "dateSend",
      key: "dateSend",
      align: "center",
      render: (text, record) => (
        <>
          {`${record.SNAM}${record.NAME1} ${record.NAME2 ? record.NAME2 : ""}`}
        </>
      ),
    },
    {
      title: "วันที่มอบงาน",
      dataIndex: "dateCeoInvestigate",
      key: "dateCeoInvestigate",
      align: "center",
      render: (text, record) => (
        <>
          {record.dateCeoInvestigate
            ? dayjs(record.dateCeoInvestigate)
                .add(543, "year")
                .format("D MMM YY")
            : null}
        </>
      ),
    },

    {
      title: "สถานะ",
      align: "center",
      render: (record) => <>{renderStatus(record)}</>,
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={12} style={{ textAlign: "left" }}>
            <Space>
              <Button
                color="blue"
                variant="outlined"
                icon={<ExportOutlined />}
                size="large"
                style={{
                  padding: "0 24px",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 14,
                }}
                loading={loading}
                onClick={putDataSend}
                disabled={selectedRows.length === 0}
              >
                ส่งสืบ{" "}
                {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
              </Button>

              <Button
                color="cyan"
                variant="outlined"
                icon={<FileExcelOutlined />} // ไอคอน
                size="small" // ขนาดเล็ก
                onClick={() => {
                  setIsModalExportListInvestigateRound(true);
                }}
                loading={loading}
              >
                นำออก Excel
              </Button>

              <Button
                color="default"
                variant="outlined"
                icon={<FileExcelOutlined />} // ไอคอน
                size="small" // ขนาดเล็ก
                onClick={() => {
                  console.log("selectedRows", selectedRows);
                  console.log("selectedRows", arrayTable);
                  exportExcelReport(
                    selectedRows.length > 0 ? selectedRows : arrayTable,
                  );
                }}
                loading={loading}
              >
                รีพอร์ต
              </Button>
            </Space>
          </Col>
          <Col span={12} style={{ textAlign: "end" }}>
            <Button
              color="green"
              variant="outlined"
              icon={<PlusCircleOutlined />}
              size="large"
              style={{
                padding: "0 24px",
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 14,

                marginRight: 10,
              }}
              onClick={() => {
                console.log("setIsModalAdd(true)");
                setIsModalAdd(true);
              }}
              loading={loading}
            >
              เพิ่มข้อมูล
            </Button>
          </Col>
          <Col span={24} style={{ textAlign: "start" }}>
            <Tooltip
              title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
              arrow={mergedArrow}
            >
              {!advanceSearch ? (
                <DownSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              ) : (
                <UpSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              )}
            </Tooltip>
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={24} style={{ textAlign: "start" }}>
              <Space size={10} wrap>
                {advanceSearch ? (
                  <>
                    <ThaiRangePicker
                      value={dateSearch}
                      onChange={setDateSearch}
                      size="large"
                    />
                    <Input
                      placeholder="ค้นหาสัญญา"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      style={{ width: "100%", borderRadius: 8 }}
                      size="small"
                      suffix={<span style={{ marginRight: 5 }}>👤</span>}
                    />
                    <Button
                      type="default"
                      icon={<FilterOutlined />}
                      size="large"
                      style={{
                        borderRadius: 8,
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        fontWeight: "bold",
                        backgroundColor: "#fff7d6",
                        color: "#333",
                        border: "1px solid #ffe58f",
                      }}
                      onClick={() => handlefilterData()}
                    >
                      กรองข้อมูล
                    </Button>
                    <Button
                      icon={<ReloadOutlined />}
                      onClick={() => {
                        setDateSearch(null);
                        setSearchInput(null);
                        setSelectedRowKeys([]);
                        setSelectedRows([]);
                      }}
                      color="red"
                      variant="outlined"
                    >
                      ล้าง
                    </Button>
                  </>
                ) : null}
              </Space>
            </Col>
            <Col span={"24"} style={{ marginTop: "10px" }}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                rowSelection={rowSelection}
                footer={() => (
                  <Flex
                    justify="space-between"
                    align="center"
                    style={{ fontWeight: 500 }}
                  >
                    <span
                      style={{
                        color: selectedRowKeys.length > 0 ? "#1890ff" : "#999",
                      }}
                    >
                      {selectedRowKeys.length > 0
                        ? `✓ เลือกแล้ว ${selectedRowKeys.length} สัญญา`
                        : "ยังไม่ได้เลือกสัญญา"}
                    </span>
                    <span>จำนวนสัญญาทั้งหมด: {arrayTable.length} รายการ</span>
                  </Flex>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalExportListInvestigateRound ? (
        <ExportListInvestigateRound
          open={isModalExportListInvestigateRound}
          close={setIsModalExportListInvestigateRound}
        />
      ) : null}
      {isModalAdd ? (
        <AddInvestigate
          open={isModalAdd}
          close={setIsModalAdd}
          dataDefault={dataRecord}
          func={reloadData}
        />
      ) : null}
    </>
  );
};

const SendInvestigateAssetOnline = MotionHoc(Main);
export default SendInvestigateAssetOnline;
